import React, { Component } from 'react'

import PropTypes from 'prop-types'

import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import BookAnAppointmentSteps from '../../Containers/BookAnAppointmentSteps'

class BookAnAppointment extends Component {
  render() {
    return <BookAnAppointmentSteps {...this.props} />
  }
}

BookAnAppointment.propTypes = {
  onClose: PropTypes.func,
  onBack: PropTypes.func,
}

export default withTheme(BookAnAppointment)
